import './vendor/slick/slick.min'
import './vendor/magnific-popup/magnific-popup.min'

    ;
(function ($) {

    // Scripts which runs after DOM load

    $(document).ready(function () {

    });

    // Scripts which runs after all elements load

    $(window).on('load', function () {


    });

    // Scripts which runs at window resize

    $(window).resize(function () {

        //jQuery code goes here

    });

}(jQuery));


